import * as angular from 'angular';
import { apsViewModels } from "../../shared/dto/APS.ViewModels";
import LoaderServiceName, { LoaderService } from "../../components/loader/loader.service";
import NotifyServiceName, { NotifyService } from "../../services/notify/notify.service";
import LineConfigsServiceName, { LineConfigsService } from "../../services/lineConfigs/lineConfigs.service";
import UIUtilityServiceName, { EnumOption, UIUtilityService } from "../../services/utility/uiUtility.service";
import { apsEnums } from "../../shared/dto/aps.enums";
import EditLineEquipmentName, { openEditLineEquipmentName } from "./editLineEquipmentName.controller";
import * as _ from "lodash";
import { States } from "../../shared/config/constant.module";
import template from './lineEquipmentNames.tpl.html';

let requires = [EditLineEquipmentName, LoaderServiceName, NotifyServiceName, LineConfigsServiceName,
  UIUtilityServiceName];

interface LineEquipmentNamesController {
  addLineEquipmentName(): void;
  editLineEquipmentName(lineEquipmentName: apsViewModels.LineEquipmentNameItem): void;
  removeLineEquipmentName(lineEquipmentName: apsViewModels.LineEquipmentNameItem): void;
}

export interface LineEquipmentNameItemDisplay extends apsViewModels.LineEquipmentNameItem {
  locationName: string;
  typeName: string;
}

class LineEquipmentNamesCtrl implements LineEquipmentNamesController {

  private loaderService: LoaderService;
  private notifyService: NotifyService;
  private $modal: mm.foundation.modal;
  private lineConfigsService: LineConfigsService;
  private lineEquipmentNames: LineEquipmentNameItemDisplay[];
  private uiUtilityService: UIUtilityService;
  private $q: angular.IQService;
  locations: EnumOption[];
  types: EnumOption[];

  setLocationAndTypeNames(item: LineEquipmentNameItemDisplay): void {
    item.locationName = _.find(this.locations, { value: item.location }).text;
    item.typeName = _.find(this.types, { value: item.type }).text;
  }

  constructor(
    loaderService: LoaderService,
    notifyService: NotifyService,
    uiUtilityService: UIUtilityService,
    $modal: mm.foundation.modal,
    lineConfigsService: LineConfigsService,
    $q: angular.IQService) {
    this.loaderService = loaderService;
    this.notifyService = notifyService;
    this.uiUtilityService = uiUtilityService;
    this.$modal = $modal;
    this.$q = $q;
    this.lineConfigsService = lineConfigsService;

    this.locations = _.sortBy(uiUtilityService.getListOptionsFromEnum(apsEnums.Location, 0), x => x.text);
    this.types = _.sortBy(uiUtilityService.getListOptionsFromEnum(apsEnums.LineEquipmentType, 1), x => x.text);

    let lineEquipmentNamesPromise = this.lineConfigsService.getLineEquipmentNames()
      .then(results => {
        this.lineEquipmentNames = results as LineEquipmentNameItemDisplay[];
        this.lineEquipmentNames.forEach(item => this.setLocationAndTypeNames(item));
      });

    loaderService.loadingPromise(lineEquipmentNamesPromise);
  }

  addLineEquipmentName(): void {
    let result = openEditLineEquipmentName({
      lineEquipmentName: {
        id: _.max(_.map(this.lineEquipmentNames, 'id')) + 1,
        location: null,
        locationName: null,
        name: null,
        type: null,
        typeName: null
      },
      locations: this.locations,
      types: this.types
    }, this.$modal);

    result.then((addedLineEquipmentName: LineEquipmentNameItemDisplay) => {
      if (addedLineEquipmentName) {
        this.lineEquipmentNames.push(addedLineEquipmentName);
      }
    });
  }

  editLineEquipmentName(lineEquipmentName: LineEquipmentNameItemDisplay): void {
    let result = openEditLineEquipmentName({
      lineEquipmentName: _.assign({}, lineEquipmentName),
      locations: this.locations,
      types: this.types
    }, this.$modal);

    result.then((updatedLineEquipmentName: LineEquipmentNameItemDisplay) => {
      if (updatedLineEquipmentName) {
        let index = _.findIndex(this.lineEquipmentNames, { id: updatedLineEquipmentName.id });
        this.lineEquipmentNames[index] = updatedLineEquipmentName;
      }
    });
  }

  removeLineEquipmentName(lineEquipmentName: LineEquipmentNameItemDisplay): void {
    let message = `Are you sure you want to permanently delete ${lineEquipmentName.name}?`;
    let subject = `Confirm Delete Line Equipment Type ${lineEquipmentName.name}`;
    let result = this.uiUtilityService.confirm(message, subject);

    result.then(confirmed => {
      if (!confirmed) {
        return;
      }

      let removeLineEquipmentPromise = this.lineConfigsService.removeLineEquipmentName({ id: lineEquipmentName.id })
        .then(() => {
          _.remove(this.lineEquipmentNames, { id: lineEquipmentName.id });
        }, this.notifyService.handleApiErrors);

      this.loaderService.loadingPromise(removeLineEquipmentPromise);
    });
  }
}

export default angular.module('aps.controller.lineEquipmentNames', requires)
  .config(($stateProvider: angular.ui.IStateProvider) => {
    $stateProvider.state({
      name: States.LINE_EQUIPMENT_NAMES,
      url: '/admin/lineConfigs/lineEquipmentTypes',
      controller: 'LineEquipmentNamesCtrl as vm',
      template: template,
      data: {
        pageTitle: 'Line Equipment Types',
        authorizeAPSIOAdmin: true
      }
    });
  })
  .controller('LineEquipmentNamesCtrl', LineEquipmentNamesCtrl)
  .name;


// WEBPACK FOOTER //
// ./src/app/controllers/lineConfigs/lineEquipmentNames.controller.ts